import { render } from "./ModalImportPanier.vue?vue&type=template&id=2761266a"
import script from "./ModalImportPanier.vue?vue&type=script&lang=js"
export * from "./ModalImportPanier.vue?vue&type=script&lang=js"

import "./ModalImportPanier.vue?vue&type=style&index=0&id=2761266a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__